import AnalysisOrb from "@/assets/img/palmistry/analysis-orb.png"

import { ProcessingCore } from "./processing-core"
import type { StepComponentProps } from "./step-contract"

/**
 * Aura processing (Figma LPR_Quiz_Aura_analysis): shared orb + sequential bars,
 * then auto-advance to checkout. Same screen as palmistry analysis, without the
 * zodiac reveal. Wired via `stepOverrides.analysis`.
 */
export function AuraProcessingStep({ step, onAdvance }: StepComponentProps) {
  return (
    <ProcessingCore
      orb={AnalysisOrb}
      title={step.title}
      checklist={step.checklist ?? []}
      onComplete={onAdvance}
    />
  )
}
